// SAMPLE PROFILES for visual demonstration only. Not real MENDWELL staff.
export const technicians = [
  {
    slug: 'sample-technician-a',
    name: 'Sample Technician A',
    role: 'Refrigeration & Cooling',
    portrait: 'https://public.readdy.ai/ai/img_res/sandbox/f2895d2f16dd8702941ce32547f07592/1802b3df-061e-4996-b201-639cd7eafb1d_mw-tech-a.webp',
    serviceSlugs: ['refrigerator-repair', 'air-conditioning-repair'],
    summary: 'Illustrative profile showing how a cooling specialist would be introduced.',
    intro: 'This sample profile demonstrates how a technician focused on refrigeration and cooling systems would be presented. Real profiles will replace it once technician records are connected.',
    repairTypes: ['Cooling and temperature faults', 'Defrost system checks', 'Door seal inspection', 'Wall-mounted unit airflow issues'],
    philosophy: 'Find the real cause first, explain it plainly, and only then recommend a repair.',
    isSample: true,
  },
  {
    slug: 'sample-technician-b',
    name: 'Sample Technician B',
    role: 'Laundry Appliances',
    portrait: 'https://public.readdy.ai/ai/img_res/sandbox/f2895d2f16dd8702941ce32547f07592/1802b3df-061e-4996-b201-639cd7eafb1d_mw-tech-b.webp',
    serviceSlugs: ['washer-dryer-repair'],
    summary: 'Illustrative profile showing how a laundry appliance specialist would be introduced.',
    intro: 'This sample profile demonstrates how a technician focused on washers and dryers would be presented. Real profiles will replace it once technician records are connected.',
    repairTypes: ['Drainage and pump faults', 'Drum and bearing noise', 'Door lock issues', 'Dryer heating checks'],
    philosophy: 'Laundry is part of a household rhythm. A tidy, unhurried visit matters as much as the fix.',
    isSample: true,
  },
  {
    slug: 'sample-technician-c',
    name: 'Sample Technician C',
    role: 'Kitchen Appliances',
    portrait: 'https://public.readdy.ai/ai/img_res/sandbox/f2895d2f16dd8702941ce32547f07592/1802b3df-061e-4996-b201-639cd7eafb1d_mw-tech-c.webp',
    serviceSlugs: ['dishwasher-repair', 'oven-range-repair'],
    summary: 'Illustrative profile showing how a kitchen appliance specialist would be introduced.',
    intro: 'This sample profile demonstrates how a technician focused on dishwashers, ovens and ranges would be presented. Real profiles will replace it once technician records are connected.',
    repairTypes: ['Dishwasher drainage and cleaning faults', 'Oven heating and temperature checks', 'Igniter and element testing', 'Control and error code diagnosis'],
    philosophy: 'Safety comes first in every kitchen. Every step is explained before it happens.',
    isSample: true,
  },
];